// extracted by mini-css-extract-plugin
var _1 = "umnNe";
var _2 = "rPkNT";
var _3 = "wFLyq";
export { _1 as "courseList", _2 as "includedCourses", _3 as "title" }
